export default __webpack_public_path__ + "static/media/e.0940d3e8.png";